import React, { useState } from 'react';
import Typography from '@src/new-components/Typography';
import CommonButton from '@src/new-components/Button';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import RecordVoiceOverRoundedIcon from '@mui/icons-material/RecordVoiceOverRounded';
import SettingsVoiceRoundedIcon from '@mui/icons-material/SettingsVoiceRounded';
import HearingDisabledRoundedIcon from '@mui/icons-material/HearingDisabledRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import NotificationDialogV3 from '@src/components/NotificationDialogV3';
import { STEPS } from '@src/constants/instantVoiceCloning';
import { useSelector } from 'react-redux';
import { VOICE_PROCESSING_STATUS } from '@src/constants/voiceCloning';
import CardGuideItem from '../CardGuideItem';
import { TipList, Title } from './index.style';

const GUIDES = [
  {
    title: 'avoidNoisyEnvironments',
    description: 'avoidNoisyEnvironmentsDesc',
    icon: <HearingDisabledRoundedIcon sx={{ color: COLOR.darkBlue }} />,
  },
  {
    title: 'checkMicrophoneQuality',
    description: 'checkMicrophoneQualityDesc',
    icon: <SettingsVoiceRoundedIcon sx={{ color: COLOR.darkBlue }} />,
  },
  {
    title: 'oneVoiceOnly',
    description: 'oneVoiceOnlyDesc',
    icon: <RecordVoiceOverRoundedIcon sx={{ color: COLOR.darkBlue }} />,
  },
];

const Header = ({ closePopupInstantVoiceCloning, step }) => {
  const { t } = useTranslation();
  const [openDialogWarning, setOpenDialogWarning] = useState(false);
  const STEP_HIDDEN_GUIDE = [STEPS.CREATE_VOICE_CLONE];
  const STEP_USE_WARNING_DIALOG = [STEPS.CREATE_VOICE_CLONE];
  const { instantVoiceTraining } =
    useSelector((state) => state.instantVoiceTraining) || {};

  const isShowWarningDialog =
    STEP_USE_WARNING_DIALOG.includes(step) &&
    ![
      VOICE_PROCESSING_STATUS.SUCCESS,
      VOICE_PROCESSING_STATUS.FAILURE,
    ].includes(instantVoiceTraining?.status);

  const renderChangeFormatButton = () => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '16px',
        padding: '0 32px',
      }}
    >
      <CommonButton
        size="small"
        variant="outlined"
        onClick={closePopupInstantVoiceCloning}
        textProps={{
          variantText: 'body-14-bold',
          color: COLOR.darkBlue,
        }}
      >
        {t('cancelSynthesisProject')}
      </CommonButton>
      <CommonButton
        size="small"
        onClick={() => setOpenDialogWarning(false)}
        variant="contained"
        textProps={{
          variantText: 'body-14-bold',
          color: COLOR.darkBlue,
        }}
      >
        {t('keepOnSynthesisProject')}
      </CommonButton>
    </Box>
  );

  return (
    <Box>
      <Title>
        <Typography
          component="p"
          color="#1C1C1E"
          variant="body-24-bold"
          gutterBottom
        >
          {t('instantVoiceClone')}
        </Typography>

        <CommonButton
          onClick={() => {
            if (isShowWarningDialog) {
              setOpenDialogWarning(true);
            } else {
              closePopupInstantVoiceCloning();
            }
          }}
          aria-label="close"
          variant="outlineSmall"
          customStyle={{
            width: '40px',
            height: '40px',
            minWidth: '40px',
          }}
        >
          <CloseRoundedIcon />
        </CommonButton>
      </Title>
      {!STEP_HIDDEN_GUIDE.includes(step) && (
        <TipList>
          {GUIDES.map((guide) => (
            <CardGuideItem
              key={guide.title}
              icon={guide.icon}
              title={t(guide.title)}
              description={t(guide.description)}
            />
          ))}
        </TipList>
      )}
      {STEP_USE_WARNING_DIALOG.includes(step) && (
        <NotificationDialogV3
          name="download-format"
          title={t('noteV2')}
          description={t('voiceCloneWarning')}
          variant="warning"
          open={openDialogWarning}
          onClose={() => setOpenDialogWarning(false)}
          actionComponent={renderChangeFormatButton()}
          padding="12px 32px"
        />
      )}
    </Box>
  );
};
export default Header;
